import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

function Partners() {
    return (

        <Row className="g-4" style={{ justifyContent: 'center', alignItems: 'stretch' }}>
            <Col xs={12} sm={12} md={4} lg={4} xl={4} style={{ display: 'flex' }}>
                <Card className="aboutCard" style={{ width: '100%' }}>
                    <Card.Body className="aboutCardBody" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '200px' }}>
                        <img
                            src={`${process.env.PUBLIC_URL}/images/partner_catering.png`}
                            alt="Partner - Catering"
                            style={{
                                width: '100%',
                                height: '90%',
                                objectFit: 'contain',
                                objectPosition: 'center',
                            }}
                        />
                    </Card.Body>
                </Card>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={4} style={{ display: 'flex' }}>
                <Card className="aboutCard" style={{ width: '100%' }}>
                    <Card.Body className="aboutCardBody" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '200px' }}>
                        <img
                            src={`${process.env.PUBLIC_URL}/images/partner_copypoint.png`}
                            alt="Partner - CopyPoint"
                            style={{
                                width: '100%',
                                height: '90%',
                                objectFit: 'contain',
                                objectPosition: 'center',
                            }}
                        />
                    </Card.Body>
                </Card>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={4} style={{ display: 'flex' }}>
                <Card className="aboutCard" style={{ width: '100%' }}>
                    <Card.Body className="aboutCardBody" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '200px' }}>
                        <img
                            src={`${process.env.PUBLIC_URL}/images/partner_druk net.png`}
                            alt="Partner - Druk Net"
                            style={{
                                width: '100%',
                                height: '90%',
                                objectFit: 'contain',
                                objectPosition: 'center',
                            }}
                        />
                    </Card.Body>
                </Card>
            </Col>
            <Col xs={12} sm={12} md={4} lg={4} xl={4} style={{ display: 'flex' }}>
                <Card className="aboutCard" style={{ width: '100%' }}>
                    <Card.Body className="aboutCardBody" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '200px' }}>
                        <img
                            src={`${process.env.PUBLIC_URL}/images/partner_innowacyjny_markenting.png`}
                            alt="Partner - Innowacyjny Marketing"
                            style={{
                                width: '100%',
                                height: '90%',
                                objectFit: 'contain',
                                objectPosition: 'center',
                                backgroundColor: '#000',
                                padding: '10px',
                            }}
                        />
                    </Card.Body>
                </Card>
            </Col>
        </Row>

    )
}

export default Partners;